// src/components/Modal.jsx
import React from "react";
import "./css/Modal.css";

export default function Modal({
  title,
  children,
  onClose,
  width,          // number or string (px, %, vw)
  height,         // optional dynamic height
  size = "md",    // "sm" | "md" | "lg" | "xl" | "full"
  className = "",
}) {
  // size presets if no explicit width is passed
  const sizeMap = {
    sm: "400px",
    md: "520px",
    lg: "720px",
    xl: "960px",
    full: "95vw",
  };

  const finalWidth = width || sizeMap[size] || sizeMap.md;
  const finalHeight = height || (size === "full" ? "90vh" : "auto");

  return (
    <div
      className="modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-label={title || "Modal"}
    >
      <div
        className={`modal-box ${className}`}
        style={{ maxWidth: finalWidth, height: finalHeight }}
      >
        <div className="modal-header">
          {title && <h3 className="modal-title">{title}</h3>}
          <button
            className="modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        <div className="modal-content">{children}</div>
      </div>
    </div>
  );
}
